import gql from 'graphql-tag'

export default gql`
  query Navigation($path: String!) {
    cfContentPageCollection(where: { path: $path }, limit: 1) {
      items {
        sys {
          id
        }
        navigationMenu
        title
      }
    }
  }
`
